import { Client } from "./client.model";
import { WorkProcess } from "./workprocess.model";

export class WorkProcessWithClient extends WorkProcess {
    client: Client | null;

    constructor(data: WorkProcessWithClient) {
        super(data);
        this.client = data.client;
    }
}
